module.exports = __webpack_public_path__ + "static/img/jin.f2cb850.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jin.jpg
// module id = ZlE8
// module chunks = 1